module.exports = __webpack_public_path__ + "img/mdm-deploy-3.1aff6974.webp";